import { useCallback } from 'react'

import fetchHelper from '@top/shared_deprecated/src/utils/api'

import { useIsProtectedRoute } from 'hooks/useIsProtectedRoute'
import { toProtectedMount } from 'utils/apiPath'
import { v4 as uuid } from 'uuid'

type Options = { headers?: Object; isForm?: boolean }

function useFetch() {
  const isProtected = useIsProtectedRoute()

  return useCallback(
    async (url: string, body?: Object, options?: Options) => {
      const traceId = uuid()
      const requestUrl = isProtected ? toProtectedMount(url) : url
      const response = await fetchHelper({
        body,
        headers: { ...options?.headers },
        url: requestUrl,
        traceId,
        withRetry: true,
      })
      if (response.statusCode >= 400) {
        throw response.error.data
      }
      return response
    },
    [isProtected]
  )
}

export type CustomFetch = ReturnType<typeof useFetch>

export default useFetch
